'use client';

import { c as _c } from "react/compiler-runtime";
import { useTranslations } from 'next-intl';
import InfoCard, { Info } from '@/app/[locale]/(create)/components/InfoCard';
import IconDiscord from '@/components/assets/icon_discord.svg';
import ImageRecap from '@/public/images/creator-intro/recap.png';
import ImageFurnitures from '@/public/images/creator-intro/toolkit-furnitures.png';
import ImagePlayground from '@/public/images/creator-intro/toolkit-playground.png';
const useReasons = () => {
  const $ = _c(44);
  const t = useTranslations();
  let t0;
  if ($[0] !== t) {
    t0 = t("creator-intro.creator-toolkit.reason-1-title");
    $[0] = t;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] !== t) {
    t1 = t("creator-intro.creator-toolkit.reason-1-description");
    $[2] = t;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {
      image: ImageRecap,
      className: "absolute md:h-auto! right-0! left-auto md:right-[-20%]! right-[-40%]! bottom-[-60%]! md:bottom-[-35%] lg:bottom-[-50%]! 3xl:-right-[32%]! 1.5xl:top-[8%]! 1.5xl:right-[-35%]!"
    };
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== t) {
    t3 = t("creator-intro.creator-toolkit.cta-1-title");
    $[5] = t;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <IconDiscord className="mr-2 size-4" />;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== t3) {
    t5 = [{
      title: t3,
      href: "https://discord.gg/viversecreators",
      variant: "secondary",
      icon: t4
    }];
    $[8] = t3;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] !== t0 || $[11] !== t1 || $[12] !== t5) {
    t6 = {
      title: t0,
      description: t1,
      background: "linear-gradient(180deg, rgba(2, 100, 205, 0.2) 0%, #21A3E2 100%)",
      backgroundImage: t2,
      blurClassName: "bg-[#21A3E2] blur-[150px]",
      ctas: t5
    };
    $[10] = t0;
    $[11] = t1;
    $[12] = t5;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  let t7;
  if ($[14] !== t) {
    t7 = t("creator-intro.creator-toolkit.reason-2-title");
    $[14] = t;
    $[15] = t7;
  } else {
    t7 = $[15];
  }
  let t8;
  if ($[16] !== t) {
    t8 = t("creator-intro.creator-toolkit.reason-2-description");
    $[16] = t;
    $[17] = t8;
  } else {
    t8 = $[17];
  }
  let t9;
  if ($[18] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = {
      image: ImageFurnitures,
      className: "absolute md:h-auto! right-[-35%]! bottom-[-50%]! lg:bottom-0! 3xl:inset-y-0! md:right-[-20%]! lg:right-[-10%]! 1.5xl:right-[-43%]!"
    };
    $[18] = t9;
  } else {
    t9 = $[18];
  }
  let t10;
  if ($[19] !== t) {
    t10 = t("creator-intro.creator-toolkit.cta-2-title");
    $[19] = t;
    $[20] = t10;
  } else {
    t10 = $[20];
  }
  let t11;
  if ($[21] !== t10) {
    t11 = [{
      title: t10,
      href: "#tutorials",
      variant: "secondary"
    }];
    $[21] = t10;
    $[22] = t11;
  } else {
    t11 = $[22];
  }
  let t12;
  if ($[23] !== t11 || $[24] !== t7 || $[25] !== t8) {
    t12 = {
      title: t7,
      description: t8,
      background: "linear-gradient(180deg, rgba(73, 1, 145, 0.2) 0%, #7C2CE4 100%)",
      backgroundImage: t9,
      blurClassName: "bg-[#7C2CE4] blur-[230px]",
      ctas: t11
    };
    $[23] = t11;
    $[24] = t7;
    $[25] = t8;
    $[26] = t12;
  } else {
    t12 = $[26];
  }
  let t13;
  if ($[27] !== t) {
    t13 = t("creator-intro.creator-toolkit.reason-3-title");
    $[27] = t;
    $[28] = t13;
  } else {
    t13 = $[28];
  }
  let t14;
  if ($[29] !== t) {
    t14 = t("creator-intro.creator-toolkit.reason-3-description");
    $[29] = t;
    $[30] = t14;
  } else {
    t14 = $[30];
  }
  let t15;
  if ($[31] === Symbol.for("react.memo_cache_sentinel")) {
    t15 = {
      image: ImagePlayground,
      className: "absolute h-auto! right-0! 1.5xl:right-[-20%]! md:right-[-10%]! bottom-[-45%]! md:bottom-[-70%]! 1.5xl:bottom-[-45%]! 3xl:top-[25%]!"
    };
    $[31] = t15;
  } else {
    t15 = $[31];
  }
  let t16;
  if ($[32] !== t) {
    t16 = t("creator-intro.creator-toolkit.cta-3-title");
    $[32] = t;
    $[33] = t16;
  } else {
    t16 = $[33];
  }
  let t17;
  if ($[34] !== t16) {
    t17 = [{
      title: t16,
      href: "https://docs.viverse.com/",
      variant: "default"
    }];
    $[34] = t16;
    $[35] = t17;
  } else {
    t17 = $[35];
  }
  let t18;
  if ($[36] !== t13 || $[37] !== t14 || $[38] !== t17) {
    t18 = {
      title: t13,
      description: t14,
      background: "linear-gradient(0deg, #6A2675 0%, rgba(129, 51, 131, 0.2) 100%)",
      backgroundImage: t15,
      blurClassName: "bg-[#6A2675] blur-[230px]",
      ctas: t17
    };
    $[36] = t13;
    $[37] = t14;
    $[38] = t17;
    $[39] = t18;
  } else {
    t18 = $[39];
  }
  let t19;
  if ($[40] !== t12 || $[41] !== t18 || $[42] !== t6) {
    t19 = [t6, t12, t18];
    $[40] = t12;
    $[41] = t18;
    $[42] = t6;
    $[43] = t19;
  } else {
    t19 = $[43];
  }
  const reasons = t19;
  return reasons;
};
function StartedWithCreatorToolkit() {
  const $ = _c(11);
  const t = useTranslations();
  const reasons = useReasons();
  let t0;
  if ($[0] !== t) {
    t0 = t.rich("creator-intro.creator-toolkit.title", {
      highlight: _temp
    });
    $[0] = t;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] !== t0) {
    t1 = <div className="md:header-2 header-3 inline w-full text-center"><span>{t0}</span></div>;
    $[2] = t0;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  if ($[4] !== reasons) {
    t2 = reasons.map(_temp2);
    $[4] = reasons;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  let t3;
  if ($[6] !== t2) {
    t3 = <div className="1.5xl:grid-cols-3 z-interactive grid grid-cols-1 gap-6">{t2}</div>;
    $[6] = t2;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  let t4;
  if ($[8] !== t1 || $[9] !== t3) {
    t4 = <section className="1.5xl:pb-[80px] 1.5xl:pt-[40px] 3xl:px-[120px] relative flex flex-1 flex-col justify-center gap-[48px] px-4 py-8 md:gap-[80px] md:px-[40px]">{t1}{t3}</section>;
    $[8] = t1;
    $[9] = t3;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  return t4;
}
function _temp2(reason, index) {
  return <InfoCard key={index} info={reason} />;
}
function _temp(chunks) {
  return <span className="text-[#E652AE]">{chunks}</span>;
}
export default StartedWithCreatorToolkit;